import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { Anchor } from '../../Components/Anchor'
import { EditIcon } from '../../Assets/Images/icons/editIcon'
import { DeleteIcon } from '../../Assets/Images/icons/DeleteIconV2'
import { AMBASSADOR_STATUS_LABEL } from '../../Reducers/Ambassador/const'
import SimpleTableTable from '../../Components/SimpleTableTable'
import { CONFIG } from '../../Config/config'
import { styles } from './styles'
import { getReadableRoleByUser } from './UserDetails/utils'

export const roleLabel = {
  [CONFIG.USER_ROLE.ADMIN]: 'Administrator',
  [CONFIG.USER_ROLE.CITY_MANAGER]: 'City Manager',
  [CONFIG.USER_SUBROLE.CITY_MANAGER_ASSISTANT]: 'City Manager Assistant',
  [CONFIG.USER_ROLE.CLIENT_ADMIN]: 'Admin',
  [CONFIG.USER_ROLE.CLIENT]: 'User',
  [CONFIG.USER_ROLE.RECRUITER]: 'Recruiter',
  [CONFIG.USER_ROLE.SPY]: 'Spy',
}

const useStyles = makeStyles(() => styles)

const getUsersTableData = ({ usersList }) =>
  usersList.map(user => {
    const { id, firstName, lastName, status, email } = user
    const role = getReadableRoleByUser(user)
    return {
      id,
      'Name': `${firstName} ${lastName}`,
      'Email address': email,
      'Role': roleLabel[role] || role,
      'Status': status,
    }
  })

const ActivityTable = ({
  usersList,
  handleUserDelete,
  history,
  match,
  ...props
}) => {
  const classes = useStyles()
  const header = ['Name', 'Email address', 'Role', 'Status', 'Actions']

  const data = getUsersTableData({ usersList })

  const postRowRender = userData => {
    const editURL = `${match.url}/${userData.id}/edit`
    const userURL = `${match.url}/${userData.id}`
    const statusColors = {
      'active': {
        background: 'rgba(0, 150, 6, 0.12)',
        color: 'rgba(0, 150, 6, 1)',
      },
      'blocked': {
        background: 'rgba(179, 15, 89, 0.12)',
        color: 'rgba(179, 15, 89, 1)',
      },
    }
    return {
      ...userData,
      'Name': (
        <Anchor href={userURL}>
          <div
            className={classes.tableCellContent}
            cypress_id={'userNameValueInTable'}
          >
            {userData.Name}
          </div>
        </Anchor>
      ),
      'Email address': (
        <Anchor href={userURL}>
          <div
            className={classes.tableCellContent}
            cypress_id={'emailAddressValueInTable'}
          >
            {userData['Email address']}
          </div>
        </Anchor>
      ),
      'Role': (
        <Anchor href={userURL}>
          <div
            className={classes.tableCellContent}
            cypress_id={'userRoleValueInTable'}
          >
            {userData['Role']}
          </div>
        </Anchor>
      ),
      'Status': (
        <Anchor href={userURL}>
          <div
            className={classes.tableCellContent}
            cypress_id={'userStatusValueInTable'}
          >
            <div
              className={classes.status}
              style={{
                color: statusColors[userData.Status]
                  ? statusColors[userData.Status].color
                  : 'none',
                backgroundColor: statusColors[userData.Status]
                  ? statusColors[userData.Status].background
                  : 'none',
              }}
            >
              {AMBASSADOR_STATUS_LABEL[userData.Status]}
            </div>
          </div>
        </Anchor>
      ),
      'Actions': (
        <div className={classes.tableCellContent}>
          <Anchor href={editURL}>
            <EditIcon />
          </Anchor>
          {userData['Role'].toLowerCase() !== 'admin' && (
            <div
              onClick={e => {
                e.stopPropagation()
                handleUserDelete(userData.id)
              }}
              className={classes.deleteIcon}
              cypress_id={'deleteIconInTable'}
            >
              <DeleteIcon />
            </div>
          )}
        </div>
      ),
    }
  }

  return (
    <SimpleTableTable
      header={header}
      data={data}
      postRowRender={postRowRender}
      {...props}
      cypress_id={props.cypress_id}
    />
  )
}

ActivityTable.propTypes = {
  usersList: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleUserDelete: PropTypes.func.isRequired,
}

export default withRouter(ActivityTable)
